import { Component, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterOption, MainDataService } from 'app/services/main-data.service';
import { LayerQcService } from 'app/services/layer-qc.service';
// import { InterLayer } from '../layer-complex/layer-complex.component';
// import { UserService } from 'app/services/user.service';

export interface InterlayerQcFilterChangeData {
	isCheckAll: boolean;
	filterOptions: FilterOption[];
}
@Component({
  selector: 'app-qc-filters-interlayers',
  templateUrl: './qc-filters-interlayers.component.html',
  styleUrls: ['../qc-filters-my-layers/qc-filters-my-layers.component.css', './qc-filters-interlayers.component.css']
})
export class QcFiltersInterlayersComponent implements OnInit, OnChanges, OnDestroy {

	// @Input() interlayer: InterLayer;
	// @Input() selectedCustomerId: number;

	isFishboneOn = false;
	filterOptions: FilterOption[];

	// @Output() onChange: EventEmitter<InterlayerQcFilterChangeData> = new EventEmitter();
	// @Output() onClickBuildFishbone: EventEmitter<any> = new EventEmitter();

	isCheckAll = true;

	private fishboneFilterInfoSub: Subscription;
	private fishboneToggleSub: Subscription;
	constructor(
		private mainDataService: MainDataService,
		private qcService: LayerQcService
		// private userService: UserService
	) { }

	onToggleFishbone() {
		this.mainDataService.fishboneToggleBS.next({
			isOn: this.isFishboneOn
		});
	}
	buildFishbone() {
		this.qcService.buildFishbone();
	}
	toggleCheckAll() {
		this.isCheckAll = !this.isCheckAll;
		this.filterOptions.forEach((d) => d.isSelected = this.isCheckAll);
		this.triggerChange();
	}
	toggleFilterOption() {
		this.triggerChange();
	}
	private triggerChange() {
		const info = this.mainDataService.fishboneFilterInfo.getValue();
		info.selectedLayerFilterOptions = this.filterOptions;
		info.isCheckAll = this.isCheckAll;
		info.source = 'filterTab';
		// this.onChange.emit({
		// 	isCheckAll: this.isCheckAll,
		// 	filterOptions: this.filterOptions
		// })
	}
	ngOnInit() {
		let isInit = true;
		this.fishboneFilterInfoSub = this.mainDataService.fishboneFilterInfo.subscribe(data => {
			if (data.source !== 'filterTab' || isInit) {
				this.filterOptions = data.selectedLayerFilterOptions;
				this.isCheckAll = data.isCheckAll;
			}
		});
		this.fishboneToggleSub = this.mainDataService.fishboneToggleBS.subscribe(data => {
			this.isFishboneOn = data.isOn;
		});
		isInit = false;
	}
	async ngOnChanges(changes: SimpleChanges) {
		// if (changes.interlayer && !changes.interlayer.firstChange) {
		// 	await this.getFilterOptions();
		// }
	}
	ngOnDestroy() {
		this.fishboneFilterInfoSub.unsubscribe();
		this.fishboneToggleSub.unsubscribe();
	}
}
